import React from 'react';
import { useConnect } from '@lore/query-connect';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import FeedHoverText from '../../feed/FeedHoverText';
import Message from './Message';

export default function OfferMessage(props) {
  const { message } = props;

  const offer = useConnect('offer.byId', {
    id: message.data.offerId
  });

  const activity = useConnect('tag.byId', {
    id: offer.data.activityId
  }, {
    enabled: !!offer.data.activityId
  });

  const launch = useDialogLauncher();

  function onClick() {
    launch(DialogManager.OfferManage.Config(offer.id));
  }

  return (
    <Message {...props}>
      {' regarding the offer'} <FeedHoverText onClick={onClick}>
        {offer.data.title || activity.data.name}
      </FeedHoverText>
    </Message>
  );
}
